import React from 'react';
import type { IconProps } from '../types';

export const ViewportWindowLevel = (props: IconProps) => (
  <svg
    width="80px"
    height="30px"
    viewBox="0 0 80 30"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0"
      y="0"
      width="80"
      height="30"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="2"
      rx="4"
      ry="4"
    />
    <text
      x="40"
      y="20"
      textAnchor="middle"
      fill="#FFFFFF"
      fontSize="14"
      fontFamily="Arial, sans-serif"
    >
      Presets
    </text>
  </svg>
);

export default ViewportWindowLevel;
